import React, { useState, useEffect } from 'react';
import { Box, Container, Alert, CircularProgress } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useAuth } from '../../../context/AuthContext';
import { useAdminData } from '../hooks/useAdminData';
import { theme } from '../styles/theme';
import AdminHeader from '../components/admin/AdminHeader';
import MetricsCards from '../components/admin/MetricsCards';
import AdminTabs from '../components/admin/AdminTabs';
import NotificationSnackbar from '../components/admin/NotificationSnackbar';

const AdminPanel = () => {
  const { isAdmin } = useAuth();
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const {
    loading,
    error,
    metrics,
    loadMetrics,
    clearError,
  } = useAdminData();

  useEffect(() => {
    if (!isAdmin()) {
      return;
    }
    loadMetrics();
  }, [isAdmin, loadMetrics]);

  const showNotification = (message, severity = 'success') => {
    setNotification({ open: true, message, severity });
  };

  const closeNotification = () => {
    setNotification({ ...notification, open: false });
  };

  if (!isAdmin()) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Alert severity="error">
          Access denied. Administrator privileges required.
        </Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
        <AdminHeader />

        <Container maxWidth="xl" sx={{ py: 4 }}>
          {error && (
            <Alert
              severity="error"
              sx={{ mb: 3, borderRadius: 2 }}
              onClose={clearError}
            >
              {error}
            </Alert>
          )}

          <MetricsCards metrics={metrics} />

          <AdminTabs showNotification={showNotification} />
        </Container>

        <NotificationSnackbar
          notification={notification}
          onClose={closeNotification}
        />
      </Box>
    </ThemeProvider>
  );
};

export default AdminPanel;
